import {environment} from '../environments/environment';
import {Injectable} from '@angular/core';
import {tileLayer} from 'leaflet';

@Injectable()
export class AppConfig {

  public readonly apiUrl = environment.apiUrl;
  public readonly oldUrl = environment.oldUrl;
  public readonly host = environment.host;
  public readonly prodHost = environment.prodHost;
  public readonly oauthUrl = environment.oauthUrl;
  public readonly osrmServiceUrl = environment.osrmServiceUrl;
  public readonly safeOsrmServiceUrl = environment.safeOsrmServiceUrl;
  public readonly osrmRouteUrl = environment.osrmRouteUrl;
  public readonly photonServiceUrl = environment.photonServiceUrl;
  public readonly photonReverseUrl = environment.photonReverseUrl;
  public readonly appleSignInUrl = environment.appleSignInUrl;
  public readonly appleClientId = environment.appleClientId;
  public readonly appleScope = environment.appleScope;
  public readonly appleRedirectUrl = environment.appleRedirectUrl;
  public readonly appleResponseType = environment.appleResponseType;
  public readonly redirectUrl = environment.redirectUrl;
  public readonly clientHost = environment.clientHost;
  public readonly tileURL = environment.tileURL;
  public readonly maxZoom = environment.maxZoom;
  public readonly tileLayerDescription = environment.tileLayerDescription;

  public getEndpoint(name: string): string {
    return `${this.apiUrl}/${name}`;
  }

  public getResetPasswordTemplate(): string {
    return `${this.clientHost}/reset/password.html`;
  }

  public getRedirectUri(): string {
    return `${this.apiUrl}/oauth2/redirect`;
  }

  public getHost(): string {
    return this.host;
  }

  public getProdHost(): string {
    return this.prodHost;
  }

  public getOldUrl(): string {
    return this.oldUrl;
  }

  public getOsrmServiceUrl(): string {
    return this.osrmServiceUrl;
  }

  public getSafeOsrmServiceUrl(): string {
    return this.safeOsrmServiceUrl;
  }

  public getOsrmRouteUrl(): string {
    return this.osrmRouteUrl;
  }

  public getPhotonServiceUrl(): string {
    return this.photonServiceUrl;
  }

  public getPhotonReverseUrl(): string {
    return this.photonReverseUrl;
  }

  public getClientHost(): string {
    if (window.location.host === 'localhost:4200') {
      return 'http://localhost:4200/';
    }

    return this.clientHost;
  }

  public getTileLayer() {
    return tileLayer(this.tileURL, {
      maxZoom: this.maxZoom,
      attribution: this.tileLayerDescription
    });
  }

  public getVerificationLink(): string {
    return `${this.clientHost}/accountverification.html`;
  }

  public getRedirectUrl(thirdParty): string {
    return `${this.oauthUrl}${thirdParty}?redirect_uri=${this.redirectUrl}`;
  }

  public getAppleUrl(): string {
    return `${this.appleSignInUrl}?client_id=${this.appleClientId}&scope=${this.appleScope}&response_type=${this.appleResponseType}&response_mode=form_post&redirect_uri=${this.appleRedirectUrl}`;
  }
}
